define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityWpEoiInfoTypeDomain = void 0;
    class FacilityWpEoiInfoTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityWpEoiInfoTypeDomain.Decommissioning, value: "Decommissioning" },
                    { key: FacilityWpEoiInfoTypeDomain.Materials, value: "Materials" },
                    { key: FacilityWpEoiInfoTypeDomain.Labour, value: "Labour" },
                    { key: FacilityWpEoiInfoTypeDomain.Transport, value: "Transport" },
                    { key: FacilityWpEoiInfoTypeDomain.Other, value: "Other" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityWpEoiInfoTypeDomain.Decommissioning] = 0;
                this.KeyIndex[FacilityWpEoiInfoTypeDomain.Materials] = 1;
                this.KeyIndex[FacilityWpEoiInfoTypeDomain.Labour] = 2;
                this.KeyIndex[FacilityWpEoiInfoTypeDomain.Transport] = 3;
                this.KeyIndex[FacilityWpEoiInfoTypeDomain.Other] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Decommissioning"] = 0;
                this.ValueIndex["Materials"] = 1;
                this.ValueIndex["Labour"] = 2;
                this.ValueIndex["Transport"] = 3;
                this.ValueIndex["Other"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityWpEoiInfoTypeDomain = FacilityWpEoiInfoTypeDomain;
    Object.defineProperty(FacilityWpEoiInfoTypeDomain, "Decommissioning", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityWpEoiInfoTypeDomain, "Materials", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityWpEoiInfoTypeDomain, "Labour", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityWpEoiInfoTypeDomain, "Transport", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FacilityWpEoiInfoTypeDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FacilityWpEoiInfoTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
